export { default } from '../../../../common/view/multi-select-cell/view.tsx';
